// Hand-composed route tree (no codegen needed).

import { createRouter } from '@tanstack/react-router';

import { rootRoute } from './routes/__root';
import { billingSuccessRoute } from './routes/billing.success';
import { directoriesRoute } from './routes/directories';
import { indexRoute } from './routes/index';
import { onboardingRoute } from './routes/onboarding';
import { pairRoute } from './routes/pair';
import { pricingRoute } from './routes/pricing';
import { privacyRoute } from './routes/privacy';
import { settingsRoute } from './routes/settings';
import { summaryRoute } from './routes/summaries.$id';
import { topicsRoute } from './routes/topics';
import { transcriptsRoute } from './routes/transcripts';
import { transcriptDetailRoute } from './routes/transcripts.$id';

const routeTree = rootRoute.addChildren([
  indexRoute,
  topicsRoute,
  settingsRoute,
  onboardingRoute,
  summaryRoute,
  pairRoute,
  directoriesRoute,
  transcriptsRoute,
  transcriptDetailRoute,
  pricingRoute,
  billingSuccessRoute,
  privacyRoute,
]);

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
